import React, { FC } from "react"
import { RRButtonFooter } from "../../atoms/roundedrectangle/RRButtonFooter"
import { Spacer, StatusBubble } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import L10n from "../../../../lib/carrot-l10n"
import { H3 } from "@carrotfertility/carotene"
import { BodySmall } from "../../atoms/Bodies"
import { ArrowLink } from "components/views/atoms/links/ArrowLink"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CarrotCardLockedModule: FC<CarrotCardModuleProps> = ({ isVirtualCard }) => (
  <RoundedRectangle backgroundColor="red-orange-white">
    <RRIconBar
      iconName="icn-carrot-cards"
      iconBackgroundColor="roman-red-40"
      label={<StatusBubble backgroundColor="roman-red" status={l`carrotCard.status.locked`} />}
    />
    <H3 variant="dark" stack="tiny">{l`carrotCard`}</H3>
    <BodySmall color="black-80">{isVirtualCard ? l`carrotCard.virtualLocked` : l`carrotCard.locked`}</BodySmall>
    {isVirtualCard && (
      <>
        <Spacer height={0.5} />
        <ArrowLink to="/talk-to-carrot/sendmessage/stolen">{l`Report lost or stolen card`}</ArrowLink>
      </>
    )}
    <RRButtonFooter to="/talk-to-carrot/sendmessage/lockedcardsupport" outline>
      {l`Contact Care Team`}
    </RRButtonFooter>
  </RoundedRectangle>
)

export { CarrotCardLockedModule }
